import { IFile } from '@sdk/contracts';

import { ButtonWrapper } from './UploadFiles.styles';

import { Upload } from '@/components/Upload';

type Props = {
  value?: IFile[];
  onChange: (files?: IFile[]) => void;
};

export const UploadFiles: React.FC<Props> = ({ value, onChange }) => {
  return (
    <ButtonWrapper>
      <Upload
        icon="DocumentAdd"
        showUploadList={false}
        mode="upload"
        accept="application/pdf,image/*"
        value={value}
        onChange={(f: IFile | IFile[] | null) => onChange([f] as IFile[])}
      />
    </ButtonWrapper>
  );
};
